import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const app = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// scripts/build-sites.js prerenders each route and marks the container with
// the path it was rendered for. Hydrate only on that exact URL: the server
// hands the same file to unknown paths and to ?query variants, and those
// render something else.
const { pathname, search } = window.location;
if (container.dataset.prerendered === pathname && !search) {
    ReactDOM.hydrateRoot(container, app);
} else {
    ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
